import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { handleUnexpectedError } from '@/app/errors';
import { useCurrentUser } from '@/app/hooks/use-current-user';
import { queryClient } from '@/app/lib/tanstack-query';
import { Button, ButtonGroup } from '@/common/components/button';
import { useRemoveOnboardingRequirement } from '@/home/queries';
import { EmptyState, EmptyStateImage, EmptyStateMessage } from '@/shared/components/empty-states';
import { userKeys } from '@/shared/user/queries';

export const Route = createFileRoute('/wizard/memberships/$member-number/complete')({
  component: CompletePage
});

function CompletePage() {
  const user = useCurrentUser();
  const navigate = useNavigate();
  const removeOnboardingRequirementMutation = useRemoveOnboardingRequirement();

  async function handleRemoveOnboardingRequirement() {
    await removeOnboardingRequirementMutation.mutateAsync(
      { },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            queryKey: userKeys.onboardingRequirement(user.id)
          });

          await navigate({ to: '/' });
        },
        onError: error => handleUnexpectedError(error)
      }
    );
  }

  return (
    <>
      <EmptyState>
        <EmptyStateImage src="/img/wizard_complete.svg" alt="An illustration of a trophy with a checkmark."/>
        <EmptyStateMessage>
          Congratulations! Your setup is complete. You may edit this information at any time by going to your settings.
        </EmptyStateMessage>
        <ButtonGroup vertical className="min-w-52">
          <Button onClick={handleRemoveOnboardingRequirement}>OK</Button>
        </ButtonGroup>
      </EmptyState>
    </>
  );
}
